import { get, post, patch, del } from './apiClient';

export function fetchUsers() {
  return get('/api/admin/users');
}

export function createUser(email, customerSlug, role) {
  return post('/api/admin/users', { email, customerSlug, role });
}

export function updateUser(username, data) {
  return patch(`/api/admin/users/${encodeURIComponent(username)}`, data);
}

export function deleteUser(username) {
  return del(`/api/admin/users/${encodeURIComponent(username)}`);
}

export function fetchCustomers() {
  return get('/api/admin/customers');
}

export function createCustomer(name, slug) {
  return post('/api/admin/customers', { name, slug });
}

export function deleteCustomer(slug) {
  return del(`/api/admin/customers/${encodeURIComponent(slug)}`);
}

export function fetchFolders(prefix = '') {
  return get(`/api/admin/folders?prefix=${encodeURIComponent(prefix)}`);
}

export function createFolder(prefix, folderName) {
  return post('/api/admin/folders', { prefix, folderName });
}

export function deleteFolder(prefix) {
  return del(`/api/admin/folders?prefix=${encodeURIComponent(prefix)}`);
}
